/* global Shopify */

import operator from 'operator';
import { hideNestedMenus } from '@/components/menu';

/**
 * Built using Operator
 * @see https://github.com/estrattonbailey/operator
 */

if (history.scrollRestoration) history.scrollRestoration = 'manual';

const router = operator('#root', [
  {
    path: '/*',
    ignore: Shopify.designMode,
  },
]);

router.on('navigate', state => {
  state.scroll.y = window.scrollY;
});

// Close menus if user navigates to another page
router.on('before', () => {
  hideNestedMenus();
});

router.on('after', ({ previousDocument, location }) => {
  document.title = previousDocument.title;
  window.history.pushState({}, '', location);
});

router.state.scroll = { y: 0 };

export default router;
